import ManagementPanel from './ManagementPanel';

export default ManagementPanel;
